export const CURRENCY_IMAGE_BASE_URL =
  "https://firebasestorage.googleapis.com/v0/b/busha-mobile/o/assets%2F";

export const TOKEN_STORAGE_KEY = "tokens";
